import React from 'react';
import { MeasurementFormProps } from './types';

import { Form } from '@heroui/form';
import { Input } from '@heroui/react';
import alertCircleIcon from '../../../assets/alert-circle.svg';

// CorrectedAgeManager/MeasurementForm.tsx
export const MeasurementForm: React.FC<MeasurementFormProps> = ({
  config,
  graphType,
  value,
  setValue,
  gender,
  age,
  percentage,
  setPercentage,
  showGraph,
  setShowGraph,
  findPercentage,
}) => {
  const ranges = graphType === 'WHO' ? config.ranges.WHO : config.ranges.FENTON;

  return (
    <Form className="mb-3">
      <div style={{ width: '100%' }}>
        <div>
          <div className="d-flex align-items-center measurement-input-container" style={{ gap: '20px' }}>
            <div className="measurement-input-wrapper" style={{ width: '33%' }}>
              <Input
                type="number"
                inputMode="decimal"
                step={0.1}
                value={value}
                placeholder={`${config.label} ב${config.unit}`}
                onFocus={(e) => e.target.select()}
                onChange={(e) => {
                  const newValue = e.target.value;
                  const numericValue = parseFloat(newValue);

                  if (!gender && newValue) {
                    setValue(newValue);
                    setPercentage('');
                    return;
                  }

                  if (
                    gender &&
                    !Number.isNaN(numericValue) &&
                    numericValue >= ranges.min &&
                    numericValue <= ranges.max
                  ) {
                    setValue(newValue);
                    findPercentage(graphType, gender, age, numericValue, config.id, setPercentage);
                    setShowGraph(true);
                    return;
                  }

                  setValue(newValue);
                  setPercentage('מחוץ לטווח');
                  if (gender) {
                    setShowGraph(true);
                  }
                }}
                classNames={{
                  inputWrapper: `
                    !bg-white border rounded-sm
                    border-blue-500
                    hover:border-blue-600
                    focus-within:border-blue-700
                    h-10 min-h-10
                  `,
                  input: "!bg-white h-full",
                }}
              />
            </div>
          </div>

          {!gender && value && (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: 0 }}>
                <img
                  src={alertCircleIcon}
                  alt="Alert"
                  style={{ width: '1rem', height: '1rem', marginRight: '4px' }}
                />
                <span className="error-message">יש לסמן את מין היילוד</span>
              </div>
            </div>
          )}

          {gender && value && percentage && (
            <div style={{ marginTop: '0.5rem' }}>
              <span className="result-text">{percentage}</span>
            </div>
          )}
        </div>
      </div>
    </Form>
  );
};